import React, { useContext } from 'react';
import { PlayContext } from '@bbkAdminComponents/play/play-context';
import { useShowDemoData } from '@bbkAdminComponents/play/use-show-demo-data';
import { TippyTooltip } from '@bbkAdminComponents/tooltips/tippy-tooltip';
import { cs } from '@bbkAdminUtils/css-utils';
import { PublishState } from '@bbkAdminUtils/api-client/rest-offers-api';

type Props = React.PropsWithChildren<{
  editableAfterLive?: boolean;
}>;

export const DisableContainer: React.FC<Props> = ({
  children,
  editableAfterLive,
}) => {
  const { play, activeEditor } = useContext(PlayContext);

  const isPlayLaunched = !!(play?.id && play?.targeting);

  const isDemoData = useShowDemoData();

  const isLiveEditor = activeEditor === PublishState.live;
  const isEditable = isPlayLaunched ? editableAfterLive : true;

  const hideTooltip = isDemoData || (!isLiveEditor && isEditable);

  // Do no delete empty div, it serves as a barrier between pointer event none and tippy tool tip
  return (
    <TippyTooltip
      content="Changes can't be made to a live play."
      tippyOptions={{
        placement: 'top-start',
        disabled: hideTooltip,
      }}
    >
      <div>
        <div
          className={cs({
            'tw-pointer-events-none tw-opacity-50': !hideTooltip,
          })}
        >
          {children}
        </div>
      </div>
    </TippyTooltip>
  );
};
